import { IDatePickerPin } from "../../types/wagons";
import { numberToWasteType } from "../../utils/enumMapping";
import { WasteType } from "../../utils/enums";
import { IWagonsDatePickerPinsResponse } from "../wagonsDatePickerReducer";

export const adaptResponseForFronted = (responseObject: IWagonsDatePickerPinsResponse[]): IDatePickerPin[] => {
  return responseObject.map((item) => ({
    date: item.date,
    wasteTypes: Array.from(new Set(item.wasteTypes.map((type) => numberToWasteType.get(type) ?? WasteType.mixed))),
  }));
};
